import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./HeroSwiper.css";

const HeroSwiper = ({ items = [], onMovieClick = () => { } }) => {
  if (!items || items.length === 0) return null;

  const placeholderPoster = "https://via.placeholder.com/334x445";
  const placeholderBackdrop = "https://via.placeholder.com/1200x640";

  return (
    <div className="hero-swiper">
      {/* Spotlight Title Section (Mobile only) */}
      <div className="hero-mobile-section-header">
        <span className="hero-section-line" />
        <h2 className="hero-section-title">In the Spotlight</h2>
        <span className="hero-section-line" />
      </div>

      <div className="hero-swiper-container">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          slidesPerView={1}
          spaceBetween={16}
          loop={true}
          centeredSlides={false}
          navigation={{
            prevEl: '.custom-swiper-prev',
            nextEl: '.custom-swiper-next',
          }}
          pagination={{
            clickable: true,
            el: '.hero-swiper-pagination'
          }}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          breakpoints={{
            320: {
              slidesPerView: 1.1,
              centeredSlides: true,
              spaceBetween: 10
            },
            768: {
              slidesPerView: 1,
              centeredSlides: false,
              spaceBetween: 0
            }
          }}
        >
          {items.map((movie, idx) => {
            const title = movie.title || movie.name || "Untitled";
            const poster =
              movie.poster || movie.image || movie.backdrop || placeholderPoster;
            const backdrop = movie.backdrop || poster || placeholderBackdrop;
            const genre = Array.isArray(movie.genre)
              ? movie.genre.join(", ")
              : movie.genre || "";
            const cert = movie.certification || movie.cert || "UA";
            const desc =
              movie.description || movie.overview || movie.synopsis || "";
            const id = movie._id || movie.id || idx;

            return (
              <SwiperSlide key={`hero-slide-${id}`}>
                {/* Responsive Slide Logic */}
                <div className="hero-slide-wrapper">
                  {/* Desktop/High-Fi View */}
                  <div className="hero-slide-desktop">
                    <div className="hero-slide-content-wrapper">
                      <div
                        className="hero-blur-bg"
                        style={{ backgroundImage: `url(${backdrop})` }}
                        aria-hidden="true"
                      />
                      <div
                        className="hero-blur-bg-overlay"
                        style={{ backgroundImage: `url(${backdrop})` }}
                        aria-hidden="true"
                      />
                      <div className="hero-gradient-overlay" aria-hidden="true" />

                      <div className="hero-slide-inner">
                        <div className="hero-info-section">
                          <div className="hero-text-content">
                            <h2 className="hero-title">{title}</h2>
                            <span className="hero-meta">{`${cert} | ${genre}`}</span>
                            <div className="hero-desc">{desc}</div>
                          </div>
                          <div className="hero-action-section">
                            <button
                              type="button"
                              className="hero-book-btn"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onMovieClick(movie._id || movie.id);
                              }}
                            >
                              <span>Book now</span>
                            </button>
                          </div>
                        </div>

                        <div className="hero-poster-section">
                          <div className="hero-poster-card">
                            <img src={poster} alt={title} className="hero-poster-img" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Mobile-Only Simplified View */}
                  <div className="hero-slide-mobile">
                    <div className="hero-mobile-card-wrap">
                      <a
                        href={`/movie/${id}`}
                        className="hero-mobile-card-link"
                        onClick={(e) => {
                          e.preventDefault();
                          onMovieClick(movie._id || movie.id);
                        }}
                      >
                        <div className="hero-mobile-card">
                          <div className="hero-mobile-poster-box">
                            <img src={poster} alt={title} className="hero-mobile-poster" />
                          </div>
                          <div className="hero-mobile-content">
                            <div className="hero-mobile-text">
                              <h3 className="hero-mobile-title">{title}</h3>
                              <span className="hero-mobile-cert">{cert}</span>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>

        {/* Dynamic Controls - Hidden on mobile via CSS */}
        <button type="button" className="custom-swiper-prev" aria-label="Previous slide">
          <div className="custom-arrow-icon prev-arrow"></div>
        </button>
        <button type="button" className="custom-swiper-next" aria-label="Next slide">
          <div className="custom-arrow-icon next-arrow"></div>
        </button>

        <div className="hero-swiper-pagination"></div>
      </div>
    </div>
  );
};

export default HeroSwiper;
